/**
 * 정규식 정보
 */
export const regConstants = {
    id: new RegExp('^[a-zA-Z0-9]{4,30}'),
    groupCd: new RegExp('^[a-zA-Z0-9]{4,30}'),
    pwd: new RegExp(''),
    tel: new RegExp('[0-9]{9,11}'),
    mobile: new RegExp('^[0-9]{10,11}'),
    number6: new RegExp('[0-9]{6}'),
    number7: new RegExp('[0-9]{7}'),
    email: new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}')
}
